import { filter } from 'lodash';
import ProductOptions from './product-options';
export default {
  props: ['variants', 'options', 'productId'],
  data: function() {
    return {
      selectedVariant: this.variants[0],
      email: '',
      errors: '',
      successMessage: ''
    }
  },
  delimiters: ['#{', '}'],
  components: {
    'product-options': ProductOptions,
  },

  methods: {
    filter: filter,
    variantChanged(variant) {
      this.selectedVariant = variant;
    },
    submit() {
      this.errors = [];
      this.successMessage = '';
      BIS.create(this.email, this.selectedVariant.id, this.productId) // create the notification
      .then(res => {
        if (res.message) {
          this.successMessage = res.message
        } else if (res.errors) {
          console.err(res.errors)
          this.errors = res.errors.base.join('<br/>')
        }
      })
    },
    close() {
      this.$emit('close');
      this.email = '';
      this.errors = '';
      this.successMessage = '';
    }

  },

  template: `
    <form class="text-center" @submit.prevent="submit">
      <div class="absolute top-1 right-2 p-1 cursor-pointer" @click="close">&#10005;</div>
      <h4 class="uppercase">Join the Waitlist</h4>
      <p class="mt-2">Get notified when your size is back in stock.</p>

      <div class="mt-6">
        <product-options
          :isBisForm="true"
          :options="options"
          :variants="variants"
          @variant-changed="variantChanged"></product-options>
      </div>

      <div class="flex mt-6">
        <input class="flex-1 border-b border-current opacity-50 focus:opacity-100 outline-none" v-model="email" type="email" id="notify_email" placeholder="Email address"/>
        <button href="#" class="ml-2 uppercase" type="submit">Submit</button>
      </div>
      <p class="mt-2 text-sm" v-if="successMessage.length > 0">#{ this.successMessage }</p>
      <p class="mt-2 text-sm" v-else-if="errors.length > 0">#{ this.errors }</p>
      </div>
    </form>
  `
}

